import "./style.css";
import Button from "react-bootstrap/Button";
import * as Icon from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import {
  addToCart,
  adjustQuantity,
  deleteFromCart,
  LoadCurrentItem,
} from "../../redux/reducers/cart-actios";

function ProductTrElement(props) {
  const dispatch = useDispatch();

  let deleteFromCart = props.deleteFromCart;
  const LoadCurrentItem = props.LoadCurrentItem;

  return (
    <tr key={props.product.id}>
      <td onClick={() => LoadCurrentItem(props.product)}>
        <Link to={`/product/${props.product.id}`}>{props.product.song_name}</Link>
      </td>
      <td className="price-new">{props.product.price}$</td>
      {/* Digital items are sold one copy each, so quantity is fixed. */}
      <td>1</td>
      <td className="subTotalShow">{props.product.price}</td>
      <td>
        <Button
          variant="dark"
          size="sm"
        className="ms-2"
        onClick={(e) => deleteFromCart(e, props.product.id)}
      >
        <Icon.Trash></Icon.Trash>
      </Button>
      </td>
    </tr>
  );
}

const mapStatetoProps = (state) => {
  return {
    currentItem: state.rCart.currentItem,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (e, product, id) => dispatch(addToCart(e, product, id)),
    adjustQuantity: (id, value) => dispatch(adjustQuantity(id, value)),
    deleteFromCart: (e, id) => dispatch(deleteFromCart(e, id)),
    LoadCurrentItem: (product) => dispatch(LoadCurrentItem(product)),
  };
};

export default connect(mapStatetoProps, mapDispatchToProps)(ProductTrElement);
